<template>
  <svg xmlns="http://www.w3.org/2000/svg" :height="size" :width="size" :fill="color" viewBox="0 -960 960 960">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
        <path d="M297.2,478l20.7-21.6L108.7,256L317.9,55.6L297.2,34L65.5,256L297.2,478z M194.1,256L425.8,34l20.7,21.6L237.3,256 l209.2,200.4L425.8,478L194.1,256z"></path>
    </g>
</svg>
</template>

<script>
  export default {
    name: 'IconPreviousItem',
    props: {
       color: {
        type: String,
        default: "#6cc7c1",
       },
       size: {
        type: String,
        default: "1.5rem",
       },
    }
  }
</script>